// extracted by mini-css-extract-plugin
export default {"header-container":"Header_header-container__XeYBq","logo":"Header_logo__Lymro","heading":"Header_heading__q85uD","motto":"Header_motto__oe8iV","bar":"Header_bar__0H8mJ"};